module.exports = __webpack_public_path__ + "static/3a-ed5ff27b9bacb8f048ec8f38100e3846.png";